// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Vk0rA","footerContact":"Footer_footerContact__EOkC+"};